"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InactiveUserArgs = exports.ActiveUserArgs = exports.StudentDetailsArgs = exports.UserDetails = exports.UserDetailsArgs = void 0;
var il_dropdown_common_1 = require("../il-dropdown/il-dropdown.common");
var get_component_1 = require("../../shared/helpers/get-component");
var user_details_card_1 = require("./user-details-card");
exports.UserDetailsArgs = {
    user: il_dropdown_common_1.StudentFilterImplementationArgs[0],
};
exports.UserDetails = (0, get_component_1.getComponent)(user_details_card_1.UserDetailsCard, exports.UserDetailsArgs);
exports.StudentDetailsArgs = {
    user: il_dropdown_common_1.StudentFilterImplementationArgs[2],
};
exports.ActiveUserArgs = {
    user: il_dropdown_common_1.StudentFilterImplementationArgs[0],
    onClickActivate: console.log,
};
exports.InactiveUserArgs = {
    user: __assign(__assign({}, il_dropdown_common_1.StudentFilterImplementationArgs[0]), { active: false }),
    onClickActivate: console.log,
};
